import { Api } from "../../helpers/api";
import { HogaApi } from "./api/hogaApi";
import { UiFlagsStore } from "../../stores/uiFlagsStore";
import { HogaResponseModel } from "../../helpers/address";
import { DefaultRequestStatus } from "./requestStatus";

export interface HogaService {
    getDataFromHoga(data: any): Promise<HogaResponseModel>;
}

export class DefaultHogaService implements HogaService {
    constructor(private api: HogaApi, private uiFlagsStore: UiFlagsStore) { }

    public getDataFromHoga(data: any): Promise<HogaResponseModel> {
        return new DefaultRequestStatus().handleRequest(() => this.api.post(Api.getHogaUrl(this.uiFlagsStore), data));
    }
}

export class HogaServiceWithResponse implements HogaService {
    public get sent() {
        return this._sent;
    }

    private _sent = false;
    constructor(private response: HogaResponseModel) { }

    public getDataFromHoga() {
        this._sent = true;
        return Promise.resolve(this.response);
    }
}

export class HogaServiceWithError implements HogaService {
    constructor(private error: any) { }

    public getDataFromHoga() {
        return Promise.reject(this.error);
    }
}

